export const COLOR_PALETTE = [
  "#435363",
  "#FF4C00",
  "#64CCC9",
  "#A0D862",
  "#EBC859",
  "#F79739",
];
